import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private currentLanguageSubject = new BehaviorSubject<string>('fr');

  currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor(
    private translate: TranslateService
  ) {

    // Langues disponibles
    this.translate.addLangs(['fr', 'en']);

    // Langue par défaut : déjà réglée via fallbackLang dans provideTranslateService()
    // (l'API setDefaultLang() de la version d'origine n'existe plus dans ngx-translate 18).

    // Langue initiale
    this.translate.use('fr');

  }


  toggleLanguage(): void {

    const currentLanguage = this.currentLanguageSubject.value;

    const newLanguage =
      currentLanguage === 'fr'
        ? 'en'
        : 'fr';

    this.translate.use(newLanguage);

    this.currentLanguageSubject.next(newLanguage);
  }


  setLanguage(language: string): void {

    if (language !== 'fr' && language !== 'en') {
      return;
    }

    this.translate.use(language);

    this.currentLanguageSubject.next(language);
  }


  getCurrentLanguage(): string {
    return this.currentLanguageSubject.value;
  }

}